module.exports = __webpack_public_path__ + "img/initiative_ac1.c7c8fcf9.jpg";